/* eslint-disable react/jsx-max-depth */
import { RouterProvider } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { fr } from 'date-fns/locale';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { frFR } from '@mui/x-date-pickers/locales';

import { SentryWrapper } from '../components/SentryWrapper';
import { ThemeContextProvider } from '../contexts/ThemeContext';
import { GlobalStyles } from '../components/GlobalStyles';
import { UiSettingsContextProvider } from '../contexts/UiSettingsContext';
import { UiContextProvider } from '../contexts/UiContext';

import { router } from './Routes';

export const App = () => (
  <SentryWrapper>
    <UiSettingsContextProvider>
      <ThemeContextProvider>
        <CssBaseline />
        <GlobalStyles />
        <SnackbarProvider maxSnack={3}>
          <LocalizationProvider
            adapterLocale={fr}
            dateAdapter={AdapterDateFns}
            localeText={
              frFR.components.MuiLocalizationProvider.defaultProps.localeText
            }
          >
            <UiContextProvider>
              <RouterProvider router={router} />
            </UiContextProvider>
          </LocalizationProvider>
        </SnackbarProvider>
      </ThemeContextProvider>
    </UiSettingsContextProvider>
  </SentryWrapper>
);
